import { IScenario } from '@/types';
import { getUrl } from '@/utils/api';

function useScenarios(filter?: string) {
  let url = `v1/scenarios`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IScenario[],
  };
}

export default useScenarios;
